import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GradeRoutingModule } from '../routingModules/grade-routing.module';
import { SharedModule } from 'src/app/shared.module';
import { GradeComponent, GradeAssignEmployeeComponent } from 'src/app/grade';
import { SetupGradeWizardComponent } from 'src/app/grade/setup-grade-wizard/setup-grade-wizard.component';
import { GridModule } from "../modules/grid.module";
import { DynamicFormsModule } from './dynamic-forms.module';
import { ClaimantDetailsComponentComponent } from '../../grade/claimant-details-component/claimant-details-component.component';
import { AssignGradePanelComponent } from '../../grade/assign-grade-panel/assign-grade-panel.component';
import {AddGradePanelComponent} from "src/app/grade/add-grade-panel/add-grade-panel.component";
import { GradeAssignCategoryPanelComponent } from 'src/app/grade/grade-assign-category/grade-assign-category-panel/grade-assign-category-panel.component';
import {GradeAssignCategoryListPanelComponent} from "src/app/grade/grade-assign-category/grade-assign-category-list-panel/grade-assign-category-list-panel.component";
import {GradeImportExportPanelComponent} from "src/app/grade/grade-import-export-panel/grade-import-export-panel.component";
@NgModule({
    imports: [
        TranslateModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        GradeRoutingModule,
        SharedModule,
        GridModule,
        DynamicFormsModule,
    ],
    declarations: [
        GradeComponent,
        GradeAssignEmployeeComponent,
        ClaimantDetailsComponentComponent,
        AssignGradePanelComponent,
        AddGradePanelComponent,
        GradeAssignCategoryPanelComponent,
        GradeAssignCategoryListPanelComponent,
        SetupGradeWizardComponent,
        GradeImportExportPanelComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    exports: [ClaimantDetailsComponentComponent, AddGradePanelComponent, GradeAssignCategoryPanelComponent,
        GradeAssignCategoryListPanelComponent,GradeAssignEmployeeComponent]
})
export class GradeModule { }
